<template>
    <div>

        <div class="kgr-row">
            {{ $t('physicalAccess.terminals.intro') }}
        </div>
        <kgr-empty-data
            v-if="terminals.length === 0 && !loading"
            :value="$t('Es wurde noch kein Zutrittsterminal angelegt.')"
        />
        <div>
            <kgr-loader v-if="loading" />
            <table
                v-else
                class="kgr-table kgr-table--striped kgr-table--block table-groups"
            >
                <thead>
                    <tr class="kgr-table__row">
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Terminal') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Regeln') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Auswirkung') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(terminal, index) in terminals"
                        :key="index"
                        class="kgr-table__row  kgr-table__row--top"
                    >
                        <td class="kgr-table__cell">
                            <kgr-input-group :error-message="terminal.name.trim() === '' ? $t('Dieses Feld sollte nicht leer sein.') : null">
                                <kgr-text-input
                                    v-model="terminal.name"
                                    :is-invalid="terminal.name.trim() === ''"
                                    @change="changeName(terminal)"
                                />
                            </kgr-input-group>
                        </td>
                        <td class="kgr-table__cell">
                            <ul class="kgr-list kgr-list--bulleted">
                                <li
                                    v-for="rule in terminal.assignments.map(assignment => assignment.rule)"
                                    :key="rule.id"
                                    class="kgr-list__item"
                                >
                                    <a
                                        :href="editUrl(rule)"
                                        class="kgr-link kgr-link--unobtrusive"
                                    >{{ rule.name }}</a>
                                </li>
                            </ul>
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-select
                                :value="options.find(option => option.value === terminal.effect)"
                                :options="options"
                                no-null-option
                                display="name"
                                @post-input="changeEffect($event, terminal)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import EmptyData from '../../components/common/EmptyData';
import GenericSelect from '../../components/common/form/select/GenericSelect';
import InputGroup from '../../components/common/form/InputGroup';
import Loading from '../../components/common/Loading';
import PhysicalAccessTerminalRepository from '../../js/repository/PhysicalAccessTerminalRepository';
import TextInput from '../../components/common/form/text-input/TextInput';

export default {
    components: {
        'kgr-input-group': InputGroup,
        'kgr-loader': Loading,
        'kgr-text-input': TextInput,
        'kgr-empty-data': EmptyData,
        'kgr-select': GenericSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            terminals: [],
            options: [
                { 'value': 'none', 'name': this.$t('Keine Auswirkung') },
                { 'value': 'set-present', 'name': this.$t('Anwesenheit setzen') },
                { 'value': 'reset-present', 'name': this.$t('Anwesenheit zurücksetzen') },
                { 'value': 'toggle-present', 'name': this.$t('Anwesenheitsstatus umdrehen') },
            ],
        }
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            this.loading = true;
            PhysicalAccessTerminalRepository
                .findByClub(this.clubId)
                .then(terminals => {
                    this.terminals = terminals;
                    this.loading = false;
                });
        },
        changeName(terminal) {
            this.update(terminal);
        },
        changeEffect(event, terminal) {
            terminal.effect = event.value;
            this.update(terminal);
        },
        async update(terminal) {
            if (this.isEditable && terminal.name.trim() !== '') {
                await PhysicalAccessTerminalRepository.update(terminal.id, terminal.name, terminal.effect);
                this.$notify.success('saveChanges.success');
            }
        },
        editUrl(rule) {
            return `/backend/clubs/physical-access/rule/${rule.id}`;
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
